const IMAGE_SIZES = ["small", "medium", "large", "full"];
const POST_CARD_IMAGE_SIZES = {
  vertical: {
    xl: {
      lg_lte: "medium",
      md_lte: "medium",
      sm_lte: "small"
    },
    lg: {
      lg_lte: "medium",
      md_lte: "medium",
      sm_lte: "small"
    },
    md: {
      lg_lte: "medium",
      md_lte: "medium",
      sm_lte: "small"
    },
    sm: {
      lg_lte: "small",
      md_lte: "small",
      sm_lte: "small"
    }
  }
};
POST_CARD_IMAGE_SIZES.horizontal = {
  ...POST_CARD_IMAGE_SIZES.vertical,
  md: {
    ...POST_CARD_IMAGE_SIZES.vertical.md,
    lg_lte: "small"
  }
};
function getPostCardImage({
  size,
  alignment,
  image
}) {
  const sizeSlug = POST_CARD_IMAGE_SIZES[alignment][size];
  const defaultImage = findSmallestImageSize({
    image,
    sizeSlug: sizeSlug == null ? void 0 : sizeSlug.lg_lte
  });
  const responsiveImageSizes = Object.entries(sizeSlug).filter((value) => value[0] !== "lg_lte").reduce((acc, [breakpoint, imageSize]) => {
    const availableSize = findSmallestImageSize({
      image,
      sizeSlug: imageSize
    });
    if (availableSize) {
      acc[breakpoint] = availableSize;
    }
    return acc;
  }, {});
  const result = {
    ...defaultImage,
    sizes: responsiveImageSizes
  };
  result.alt = image == null ? void 0 : image.altText;
  return result;
}
function getPostCardImageRadius({
  size,
  alignment
}) {
  if ((alignment === "vertical" || alignment === "horizontal") && size === "xl") {
    return "$radii.md";
  }
  return 0;
}
function findSmallestImageSize({
  image,
  sizeSlug
}) {
  var _a, _b;
  const indexOfRequestedSize = IMAGE_SIZES.indexOf(sizeSlug);
  const availableSizes = IMAGE_SIZES.slice(indexOfRequestedSize);
  for (let i = 0; i < availableSizes.length; i += 1) {
    const imageSize = availableSizes[i];
    if ((_a = image == null ? void 0 : image.mediaDetails) == null ? void 0 : _a.sizes[imageSize]) {
      return (_b = image == null ? void 0 : image.mediaDetails) == null ? void 0 : _b.sizes[imageSize];
    }
  }
  return image || null;
}
export {
  getPostCardImage,
  getPostCardImageRadius
};
